import { appAPI } from "../../../api";
import { IUser } from "../../../models/IUser";

const usersPath = `/users`;

const toError = (error: any) =>
    new Error(
        error.response?.data?.message ||
        `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`,
    );

export const userAPI = {
  getAll: async () => {
    try {
      const res = await appAPI.get(usersPath);
      return res.data;
    } catch (error: any) {
      throw toError(error);
    }
  },
  /** Профиль самого себя. Целевой пользователь определяется по токену. */
  update: async (updateData: IUser) => {
    try {
      const res = await appAPI.put(usersPath, updateData);
      return res.data;
    } catch (error: any) {
      throw toError(error);
    }
  },
  /** Смена должности сотрудника (только руководитель). */
  updateRole: async (userId: string, role_id: number) => {
    try {
      const res = await appAPI.patch(`${usersPath}/${userId}/role`, { role_id });
      return res.data;
    } catch (error: any) {
      throw toError(error);
    }
  },
  /** Смена рабочего статуса сотрудника (только руководитель). */
  updateStatus: async (userId: string, status_id: number) => {
    try {
      const res = await appAPI.patch(`${usersPath}/${userId}/status`, {
        status_id,
      });
      return res.data;
    } catch (error: any) {
      throw toError(error);
    }
  },
};